import { useMutation } from "@apollo/client";
import {
  Button,
  ButtonGroup,
  ControlGroup,
  MenuItem,
  Tag,
} from "@blueprintjs/core";
import { Select2 } from "@blueprintjs/select";
import _, { isEqual } from "lodash";
import { useEffect, useState } from "react";
import {
  ArticleParameter,
  UpdateArticleParameterInput,
} from "../../../../api/schema";
import { ValuesVariables } from "../../../../components/form/InputForm";
import { resolve_lang, UserLanguage } from "../../../../lang/lang";
import { AppToaster } from "../../../Template";
import {
  DeleteArticleParameterMutation,
  DeleteArticleParameterResponse,
  UpdateArticleParameterMutation,
} from "../../helper/graphql";
import { SimpleButton } from "../../ui/SimpleButton";

interface FloatFieldProps {
  parameter: ArticleParameter;
  on_changed: () => void;
}

export const SelectField = (props: FloatFieldProps) => {
  const [delete_parameter_mutation] =
    useMutation<DeleteArticleParameterResponse>(DeleteArticleParameterMutation);

  const [update_parameter_mutation] = useMutation<
    ArticleParameter,
    ValuesVariables<UpdateArticleParameterInput>
  >(UpdateArticleParameterMutation);

  console.log("building float field", props);

  const field = props.parameter;
  const key_field = field.key_field;

  const [submitting, set_submitting] = useState(false);

  const [field_value, set_field_value] = useState(field.value);

  const [is_value_edited, set_value_edited] = useState(false);

  useEffect(() => {
    set_value_edited(!isEqual(field.value, field_value));
  }, [field_value, field.value]);

  const save_parameter = () => {
    if (!is_value_edited) return;

    set_submitting(true);

    const variables: ValuesVariables<UpdateArticleParameterInput> = {
      values: {
        id: field.id,
      },
    };

    if (is_value_edited) variables.values.value = field_value;

    update_parameter_mutation({ variables }).then((res) => {
      console.log("update_article_parameter", res);
      if (res.data) {
        AppToaster.show({
          message: UserLanguage().results.saved,
          intent: "success",
          icon: "tick",
        });
        set_submitting(false);
        props.on_changed();
      }
    });
  };

  const remove_parameter = () => {
    if (field.key_field.required) return;

    delete_parameter_mutation({ variables: { id: field.id } }).then((res) => {
      console.log("delete_article_parameter", res);
      if (res.data) {
        AppToaster.show({
          message: UserLanguage().results.deleted,
          intent: "success",
          icon: "tick",
        });
        props.on_changed();
      }
    });
  };

  return (
    <ControlGroup style={{ marginBottom: 10 }}>
      <Tag large intent={"none"} style={{ flexShrink: 0, marginRight: 5 }}>
        {resolve_lang(field.key_field.name, UserLanguage().data.fields)}
      </Tag>
      <Select2<string>
        disabled={submitting}
        items={key_field.values}
        itemListPredicate={(query, items) => {
          const lq = query.toLowerCase();
          return _.filter(items, (i) => i.toLowerCase().indexOf(lq) !== -1);
        }}
        itemRenderer={(v, { handleClick, modifiers }) =>
          modifiers.matchesPredicate ? (
            <MenuItem
              text={v}
              onClick={handleClick}
              key={field.id + "_" + v}
              active={modifiers.active}
            />
          ) : null
        }
        onItemSelect={(i) => set_field_value(i)}
        filterable={true}
        fill
      >
        <Button text={field_value} key={field.id} fill />
      </Select2>
      <ButtonGroup>
        <SimpleButton
          disabled={submitting}
          enabled={is_value_edited}
          intent="success"
          onClick={save_parameter}
          icon="edit"
        />
        <SimpleButton
          disabled={submitting}
          enabled={field.key_field.required}
          intent="danger"
          onClick={remove_parameter}
          icon="cross"
        />
      </ButtonGroup>
    </ControlGroup>
  );
};
